module.exports = __webpack_public_path__ + "img/JunNishimura_企画書_ページ_02.2d6009c0.jpg";